import store from "store";
import DetectDarkMode from "detect-dark-mode";

export const saveDarkMode = (mode: boolean) => {
    if (!process.env.WEBPACK) return;
    store.set("darkMode", mode.toString());
};

export const getDarkMode = () => {
    if (!process.env.WEBPACK) return;
    const hwStorage = store.get("darkMode") || DetectDarkMode.isDark.toString();
    return hwStorage === "true";
};